/**
 * footer nav
 * make it look app-ish
 */

import React from 'react';
import SettingsIcon from 'react-icons/lib/io/gear-a';
import WineIcon from 'react-icons/lib/io/wineglass';
import TimeIcon from 'react-icons/lib/io/android-time';

import { CALCULATOR, DRINKS, SETTINGS } from '../stores/route';
import { navigate } from '../actions/route';


const DrinksBadge = props => !!props.drinks.drinks.length && (
  <b>({props.drinks.drinks.length})</b>
)

const NavButton = props => (
  <button
    className={`${props.currentRoute === props.route && 'active'}`}
    onClick={() => navigate(props.route)}
  >{props.children}</button>
);

const Navigation = props => {
  const currentRoute = props.route.route;
  return (
    <nav id="navigation">
      <NavButton route={DRINKS} currentRoute={currentRoute}>
        <TimeIcon />
        <span>Tracker <DrinksBadge drinks={props.drinks} /></span>
      </NavButton>
      <NavButton route={CALCULATOR} currentRoute={currentRoute}>
        <WineIcon />
        <span>Add Drink</span>
      </NavButton>
      <NavButton route={SETTINGS} currentRoute={currentRoute}>
        <SettingsIcon />
        <span>Settings</span>
      </NavButton>
    </nav>
  );
};

export default Navigation;



// WEBPACK FOOTER //
// ./src/components/navigation.js